import { render, staticRenderFns } from "./UserBlocked.vue?vue&type=template&id=2e66f27e&scoped=true&"
import script from "./UserBlocked.vue?vue&type=script&lang=js&"
export * from "./UserBlocked.vue?vue&type=script&lang=js&"
import style0 from "./UserBlocked.vue?vue&type=style&index=0&id=2e66f27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e66f27e",
  null
  
)

export default component.exports